/**
 * A symptom type for the SymptomLike model.
 */
class SymptomType {
  static NOT_SET: SymptomType;
  static SYMPTOM: SymptomType;
  static FINDING: SymptomType;
  static ANAMNESIS: SymptomType;

  private static _values: SymptomType[] = [];
  private static _lookup: Map<number, SymptomType> = new Map();

  static fromKey(key?: number) {
    const symptomType = SymptomType._lookup.get(key !== undefined ? key : -1);
    if (symptomType === undefined) {
      throw new Error('Not a valid SymptomType.key: ' + key);
    }
    return symptomType;
  }

  static values(): SymptomType[] {
    return [...SymptomType._values];
  }

  // ---

  public readonly key: number;
  public readonly label: string;
  public readonly plural: string;
  public readonly className: string;

  constructor(key: number, label: string, plural: string) {
    this.key = key;
    this.label = label;
    this.plural = plural;
    this.className = plural.toLowerCase().replace(' ', '-');
    SymptomType._values.push(this);
    SymptomType._lookup.set(key, this);
  }

  get labelLower() {
    return this.label.toLowerCase();
  }

  get pluralLower() {
    return this.plural.toLowerCase();
  }

  toString() {
    return '<SymptomType: ' + this.label + '>';
  }
}

SymptomType.NOT_SET = new SymptomType(0, 'n/a', 'n/a');
SymptomType.SYMPTOM = new SymptomType(1, 'Symptom', 'Symptoms');
SymptomType.FINDING = new SymptomType(2, 'Clinical finding', 'Clinical findings');
SymptomType.ANAMNESIS = new SymptomType(3, 'Anamnesis', 'Anamneses');

export { SymptomType };
